<template>
  <SectionView class="diet" :title="title" :tips="tips">
    <p>{{content}}</p>
  </SectionView>
</template>

<script>
  import SectionView from "@/components/SectionView";

  /**
   * 文本卡片
   */
  export default {
    name: "TextCard",
    components: {SectionView},

    props: {
      // 提示
      tips: {
        type: Boolean,
        default: false
      },
      // 标题
      title: {
        type: String,
        default: '项目说明'
      },
      // 内容
      content: {
        type: String,
        require: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  p {
    font-size: 30px;
    color: #333333;
    line-height: 46px;
    text-align: justify;
  }
</style>